@use "src/sedestral/sass/extends/editor";
@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackGuideContent {
  width: 100%;
  color: var(--black) !important;
  word-break: break-word;

  h1, h2, h3, h4, h5, h6, p, ul, li, p, a {
    all: revert;
  }

  @include editor.tags;
  @include editor.tagsDocs;

  h2 {
    font-size: 28px;
    margin: 35px 0;

    &:first-child {
      margin: 15px 0px 35px 0px !important;
    }
  }

  h3 {
    font-size: 24px;
    margin: 30px 0;
  }

  h4 {
    font-size: 22px;
    margin: 25px 0;

    @include texts.font("semi-bold");
  }

  h5 {
    font-size: 18px;
    margin: 20px 0;

    @include texts.font("semi-bold");
  }

  table {
    margin-top: 35px;
    margin-bottom: 35px;
  }

  img {
    display: block;
    float: unset;
    margin: auto;
    cursor: zoom-in !important;
    max-width: 100%;
    height: auto;
    margin-bottom: 40px !important;
    margin-top: 40px !important;
    border: 1px solid var(--grey-sur);
  }

  a {
    color: var(--web-blue);
  }

  blockquote {
    border: 2px solid var(--web-blue) !important;
    background: var(--web-blue-alpha);
    padding: 15px !important;
    margin: 30px 0 !important;
    border-radius: 12px;
  }

  .reduce {
    &.open {
      .arrow {
        .icon {
          transform: rotate(0deg) !important;
        }
      }
    }

    .head {
      margin: 35px 0 35px;
      display: flex;
      align-items: center;
      gap: 12px;
      cursor: pointer;

      h2 {
        margin: 0 !important;
      }

      .arrow {
        width: 28px;
        height: 28px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background: var(--grey-sur);
        }

        .icon {
          width: 18px;
          height: 18px;
          transform: rotate(90deg);
          transition: 0.2s;

          @include icons.ico("black-bottom-bold");
        }
      }
    }
  }

  .reduceContent {
    display: none;
    font-size: 13px;

    p {
      margin-top: 0 !important;
    }
  }

  .loader {
    height: calc(100% - 60px);
    position: absolute;
    width: 100%;
    padding-top: 15px;
  }
}